import { MButton } from '@Components/Base';

interface VendorFooterProps {
  onSplitQty: () => void;
}

const VendorFooter: React.FC<VendorFooterProps> = ({ onSplitQty }) => {
  return (
    <div>
      <MButton type="primary" style={{ width: '100%' }} onClick={onSplitQty}>
        Split Quantity
      </MButton>
    </div>
  );
};

export default VendorFooter;
